<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<el-tabs class="mt-3" v-model="type" @tab-click="handleClick" type="card">
		   <el-tab-pane  :label="layout.user.type==1?$t('dayList.agent'):$t('upay.mypay')" name="1"></el-tab-pane>
		   <el-tab-pane  :label="$t('cdn.user')" name="2"></el-tab-pane>
		   
		 </el-tabs>
		
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						
						<el-form-item v-if="type=='1' && layout.user.type==1" :label="$t('upay.aid')" class="mb-0">
							<el-input size="small" v-model="from.fid" ></el-input>
						</el-form-item>
						<el-form-item v-if="type=='1' && layout.user.type==1" :label="$t('upay.aname')" class="mb-0">
							<el-input size="small" v-model="from.fname" ></el-input>
						</el-form-item>
						
						
						<el-form-item v-if="type=='2'" :label="$t('payList.uid')" class="mb-0">
							<el-input size="small" v-model="from.fid" ></el-input>
						</el-form-item>
						<el-form-item v-if="type=='2'" :label="$t('userList.userName')" class="mb-0">
							<el-input size="small" v-model="from.fname" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('upay.order_no')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						
						
						
						
						
						
						<el-form-item :label="$t('upay.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="statusText('pending')" value="pending">{{statusText('pending')}}</el-option>
								<el-option :label="statusText('paid')" value="paid">{{statusText('paid')}}</el-option>
								<el-option :label="statusText('expired')" value="expired">{{statusText('expired')}}</el-option>
								<el-option :label="statusText('canceled')" value="canceled">{{statusText('canceled')}}</el-option>
							</el-select>
						</el-form-item>
						
						
						
						
						
						
						
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						
						
						
						<el-button type="success" size="small" v-if="layout.user.type==2  && type=='1'" @click="openModel(false)"  >{{$t('layout.pay')}}</el-button>
						
						<span v-if="layout.user.type==2 && type=='1'" style="font-weight: bold;" class="ml-3">{{$t('home.my_money')}}: 
						<span class="text_chengse">$ {{money}}</span></span>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<!-- <el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column> -->
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				<el-table-column width="300" align="center" prop="order_no" :label="$t('upay.order_no')">
				</el-table-column>
				
				
				<el-table-column width="140"  align="center" prop="money" :label="$t('upay.money')">
					
					<template slot-scope="scope">
					<span style="color: #67C23A;font-weight: bold;">{{scope.row.money}} USDT</span>
					
									
					</template>
				</el-table-column>
				
				<el-table-column align="center" v-if="layout.user.type==1 && type=='1'" prop="agent_name" :label="$t('dayList.agent')">
					
				</el-table-column>
				
				
				<el-table-column v-if="type=='2'" align="center" width="140" prop="user_name" :label="$t('cdn.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="350" prop="status" :label="$t('upay.status')">
					<template slot-scope="scope">
					<el-tag :type="statusType(scope.row.status)" effect="dark" size="small">
					  {{ statusText(scope.row.status) }}
					</el-tag>
					
					
				
					</template>
				</el-table-column>
				
				
				
				
				
				
				
				<el-table-column align="center" width="350" prop="wallet_address" :label="$t('upay.wallet_address')">
					<template slot-scope="scope">
						
						
					<span v-if="type=='1'  || layout.user.type==1">{{ scope.row.wallet_address }}</span>
					
					
					
					<span v-if="type=='1' || layout.user.type==1" class="iconCopy" @click="copyText(scope.row.wallet_address)"><i class="iconfont icon-fuzhi"></i></span>
					
					<span v-if="type=='2' && layout.user.type==2">-</span>
					</template>
				</el-table-column>
				
				
			
				
				
				
				
				
				
				
				
				
				
				
				
			
				
				
				
				
				
				
				
				
			
				
				
				
				
				
				
				
				
				
				
				
				
				
				
				
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="expire_time" :label="$t('upay.end_time')">
				</el-table-column>
				
				
				<el-table-column  align="center" width="200" prop="remark" :label="$t('upay.remark')">
					<template slot-scope="scope">
					<el-tooltip class="item" effect="light" :content="scope.row.remark" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.remark }}</span>
					 
					</el-tooltip>
					
				
					</template>
				</el-table-column>
				
				
			
				
		
				<el-table-column :width="layout.user.type==1?140:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope" v-if="type=='1' || layout.user.type==1">
						<el-button-group>
							<el-button  @click="openModel(scope.row)"  size="mini" plain type="success">{{$t('system.look')}}</el-button>
							
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>



		<!-- 充值弹窗 -->
		
		
	
		
		<RechargeDialog :is_phone="layout.is_phone" :check_id="check_id" :recModel="createModel" @hide="createModel = false"  @successSub="successSub" @changeStatus="changeStatus"></RechargeDialog>

	</div>
</template>


<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	import RechargeDialog from '@/components/common/RechargeDialog.vue'

	export default {
		components: {
			buttonSearch,
			RechargeDialog
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				type:"1",
				createModel: false,
				editIndex: -1,
				money:0,
				//搜索數据
				from: {
					name: '',
					username:'',
					fid:"",
					fname:"",
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					cloud_id:-1,
					ac_id:'',
					time:[],
				},
				auth_val: 'Account',
				odds:0,
				preUrl: "user/upayList", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/delAccount", //删除單条地址
				addUrl: "data/addAccount", //添加/修改地址
				editStatusUrl:"data/editStatusAccount",//修改狀態地址
				agentData:[],
				tableData: [],
				check_id:0,
				form: {

				},

				rules: {
	
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			if(this.layout.user.type==2){
				this.commonList('selfMoney');
			}
			
		},
		methods: {
			changeStatus(id,status){
				let i = this.tableData.findIndex(item=>item.id==id)
				if(i!=-1){
					this.tableData[i].status = status
					
					if(status=='paid' && this.layout.user.type==2){
						this.commonList('selfMoney');
					}
				}
			},
			// 状态 -> el-tag 类型
			statusType(status) {
			  const map = {
			    pending: 'warning',
			    paid: 'success',
			    expired: 'info',
			    canceled: 'info',
			  };
			  return map[status] || 'info';
			},
			// 状态 -> 文案（如需 i18n 可替换为 this.$t(...)）
			statusText(status) {
			  const map = {
			    pending: this.$t('upay.pending'),
			    paid: this.$t('upay.paid'),
			    expired: this.$t('upay.expired'),
			    canceled: this.$t('upay.canceled'),
			  };
			  return map[status] || status || this.$t('upay.no');
			},
			successSub(id){
				if(id!=0){
					this.getList()
					this.check_id = id
				}
				
			},
			
			getBtnType(status){
				if(status==1){
					return 'success';
				}else if(status==0){
					return 'danger';
				}else if(status==3){
					return 'warning';
				}else{
					return 'info';
				}
			},
			changeAcStatus(data){
				this.form_remark = {
					id:data.id,
					status:data.status,
					remark:''
				}
			
				this.remarkModel = true
			},
			submitRemark(){
				this.$refs.form_remark.validate(res => {
					
					if (res) {
						this.changeAcStatusApi(this.form_remark)
					}
				})
			},
			changeAcStatusApi(data){
				//this.layout.loading = true;
				this.axios.post(this.changeStatusUrl(), {
					id: data.id,
					remark: data.remark,
					status: data.status,
					type: 'account_status',
				}, {
					token: true,
				}).then(res => {
					let all = res.data;
					console.log(all)
					if (all.code == 1) {
						this.$message({
							message:all.msg,
							type: 'success'
						});
						let index  = this.tableData.findIndex(item=>item.id == data.id)
						this.tableData[index].account_status = data.status
						if(data.status==2){
							this.getList()
						}
					}
					this.remarkModel = false
					//this.layout.loading = false;
				}).catch(err => {
					//this.layout.loading = false;
					this.$message.error(this.$t('system.openFailed'));
				});
			},
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changePassShowEmail(item){
				item.showPassEmail = item.showPassEmail==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {

				this.$refs.form.validate(res => {
					
					if (res) {
						this.form.id = this.editIndex
						this.subUpayApi()
						// 關閉模态框
					}
				})
			},
			
			
			
			

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.check_id = 0
				} else {
					// 修改
					
					this.check_id = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					if(type=='selfMoney'){
						this.money = list.money
					}

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					fid:"",
					fname:"",
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					cloud_id:-1,
					ac_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
